import { useCallback, useEffect, useRef, useState } from 'react';
import { listOtoMemories, createOtoMemory, reviseOtoMemory, decideOtoMemory } from '../services/api/oto';
import { formatApiError } from '../utils/apiError';

export const useOtoMemory = () => {
  const [items, setItems] = useState([]);
  const [canManageTeam, setCanManageTeam] = useState(false);
  const [loading, setLoading] = useState(false);
  const [acting, setActing] = useState(false);
  const [error, setError] = useState('');
  const version = useRef(0);
  const pending = useRef(false);
  const alive = useRef(true);
  const refresh = useCallback(async ({ clearError = true } = {}) => {
    const request = ++version.current;
    setLoading(true);
    try {
      const { data } = await listOtoMemories();
      if (alive.current && request === version.current) { setItems(data.items); setCanManageTeam(data.can_manage_team); if (clearError) setError(''); }
    } catch (err) { if (alive.current && request === version.current) setError(formatApiError(err, 'Mémoire indisponible.')); }
    finally { if (alive.current && request === version.current) setLoading(false); }
  }, []);
  useEffect(() => { alive.current = true; refresh(); return () => { alive.current = false; version.current += 1; }; }, [refresh]);
  const run = async action => {
    if (pending.current) return false;
    pending.current = true; setActing(true); setError('');
    try { await action(); await refresh(); return true; }
    catch (err) { if (alive.current) setError(formatApiError(err, 'La mémoire n’a pas été modifiée.')); await refresh({ clearError: false }); return false; }
    finally { pending.current = false; if (alive.current) setActing(false); }
  };
  return { items, canManageTeam, loading, acting, error, refresh,
    save: (data, original) => run(() => original ? reviseOtoMemory(original.id, { ...data, version: original.version }) : createOtoMemory(data)),
    decide: (item, operation) => run(() => decideOtoMemory(item.id, operation, item.version)) };
};